import { MasterDialog } from "#common/Dialog/Dialog"
import InputNumber from "#common/input/InputNumber"
import { useApiSend } from "#hooks/useApiSend"
import { MINIMUM_PAYMENT, MINIMUM_PAYMENT_MONTHLY_TEXT } from "#savings-fund/constants"
import { UseSavingsFundContext } from "#savings-fund/contexts/contexts"
import { savingsFundPost } from "#savings-fund/services/Api"
import { Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Checkbox from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Typography from "@mui/material/Typography"
import { useCallback, useState } from "react"
import { toast } from "react-toastify"
import InputDateSaving from "./InputDateSaving"

function Formulario({ open, setOpen = () => {} }) {
	const [value, setValue] = useState({
		deduccion: 0,
		fecha_ingreso: "",
	})
	const [check, setCheck] = useState(false)
	const buttons = InputCheck({ value, check })

	return (
		<MasterDialog
			maxWidth="md"
			open={open}
			onClose={() => {
				setOpen(false)
			}}
			title="Solicitud Caja De Ahorro"
			buttons={buttons}
		>
			<Stack spacing={2}>
				<InputNumber
					label="$ Deducción Quincenal"
					setValue={(deduccion) => {
						setValue((old) => ({ ...old, deduccion }))
					}}
				/>
				<Typography variant="h5">{`Deducción Mensual : $${(
					value.deduccion * 2
				).toLocaleString("en-US")}`}</Typography>
				<InputDateSaving
					value={value.fecha_ingreso}
					setValue={(fecha_ingreso) => {
						setValue((old) => ({ ...old, fecha_ingreso }))
					}}
				/>
				<Condition />

				<FormControl>
					<FormLabel component="legend"></FormLabel>
					<FormControlLabel
						checked={check}
						onChange={(event) => setCheck(event.target.checked)}
						required
						control={<Checkbox />}
						label={`Acepto los términos y condiciones`}
					/>
				</FormControl>
			</Stack>
		</MasterDialog>
	)
}

export default Formulario

function Condition() {
	return (
		<Box
			sx={{
				margin: 2,
			}}
		>
			<Typography>
				Al hacer tu solicitud de Caja de Ahorro, aceptas los términos y
				condiciones de la caja de ahorro.
				<br />
				Para consultarlos, puedes hacerlo en el apartado de documentación Lubtrac,
				en la sección de Estatutos de Caja de Ahorro.
			</Typography>
		</Box>
	)
}
export function InputCheck({ value, check }) {
	const { refreshData, colaborador } = UseSavingsFundContext()
	const [disabled, setDisabled] = useState(false)
	const success = useCallback(() => {
		refreshData()
	}, [refreshData])

	const { fetch } = useApiSend(savingsFundPost, {
		success,
		end: () => setDisabled(false),
	})

	const handleSend = () => {
		if (!value["deduccion"]) {
			toast.error("Se requieren la deducción")
			return
		}
		if (!value["fecha_ingreso"]) {
			toast.error("Se requieren la fecha de ingreso")
			return
		}
		if (!check) {
			toast.error(`Se deben aceptar términos y condiciones `.toUpperCase())
			return
		}
		if (value["deduccion"] < MINIMUM_PAYMENT) {
			toast.error(
				`El monto mínimo es de ${MINIMUM_PAYMENT_MONTHLY_TEXT}`.toUpperCase()
			)
			return
		}
		setDisabled(true)
		fetch({ ...value, colaborador_id: colaborador })
	}
	return [{ label: "enviar", disabled, onClick: handleSend }]
}
